


<template>
  <v-app>
    <v-container fluid class="error-page">
      <v-row class="d-flex justify-center">
        <v-col cols="8">
          <div class="card">
            <span class="error-logo">404</span>
            <p class="error-text">Página no encontrada</p>
            <p class="error-subtext">Lo sentimos, pero la página solicitada no ha sido encontrada en este servidor.</p>
             <v-btn
              class="text-capitalize primary"
              dark
              x-large
              :color="config.light.primary"
              @click="regresar"
              >
              Regresar a inicio
            </v-btn>
          </div>
        </v-col>
      </v-row>
  </v-container>
  </v-app>
</template>

<script>
import config from '@/config';
import {mapState} from 'vuex';

export default {
  name: 'Error',
  data(){
    return{
      config
    }
  },
  computed: {
        ...mapState(['domain'])
    },
    methods: {
        regresar() {
            window.location.href = this.domain.domainNameWithHttp;
        }
    }
};
</script>

<style src="./PageNotFound.scss" lang="scss"></style>